"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProfitLiftSegmentationEnum_1 = require("../model/segmentation-model-set/ProfitLiftSegmentationEnum");

var SalesLiftSegmentationEnum_1 = require("../model/segmentation-model-set/SalesLiftSegmentationEnum");

var SegmentationItemEnum_1 = require("../model/segmentation-model-set/SegmentationItemEnum");

var SegmentationModelItem_1 = require("../model/segmentation-model-set/SegmentationModelItem");

var SegmentationModel_1 = require("../model/SegmentationModel");

var SegmentationModelConverter_1 = require("./SegmentationModelConverter");
/**
 * Default implementation of SegmentationModelConverterConverter.
 *
 * @author ZSr
 */


var SegmentationModelConverterImpl =
/*#__PURE__*/
function (_SegmentationModelCon) {
  _inherits(SegmentationModelConverterImpl, _SegmentationModelCon);

  function SegmentationModelConverterImpl() {
    _classCallCheck(this, SegmentationModelConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SegmentationModelConverterImpl).apply(this, arguments));
  }

  _createClass(SegmentationModelConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SegmentationModel_1.SegmentationModel(conversions.documentToClassId(source), SegmentationModel_1.SegmentationModel.schema.enableStatus.valueOfField(source), SegmentationModel_1.SegmentationModel.schema.highSalesLift.valueOfField(source), SegmentationModel_1.SegmentationModel.schema.lowSalesLift.valueOfField(source), SegmentationModel_1.SegmentationModel.schema.highBM2Lift.valueOfField(source), conversions.asObjectList(source, 'segmentationModelItem', this.deserializeSegmentationModelItem(conversions)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        enableStatus: source.enableStatus,
        highSalesLift: source.highSalesLift,
        lowSalesLift: source.lowSalesLift,
        highBM2Lift: source.highBM2Lift,
        segmentationModelItem: conversions.asObjectArray(source, 'segmentationModelItem', this.serializeSegmentationModelItem())
      });
      return result;
    }
  }, {
    key: "deserializeSegmentationModelItem",
    value: function deserializeSegmentationModelItem(conversions) {
      return function (document) {
        return new SegmentationModelItem_1.SegmentationModelItem(conversions.asEnum(document.salesLift, SalesLiftSegmentationEnum_1.SalesLiftSegmentationEnum), conversions.asEnum(document.profitLift, ProfitLiftSegmentationEnum_1.ProfitLiftSegmentationEnum), conversions.asEnum(document.value, SegmentationItemEnum_1.SegmentationItemEnum));
      };
    }
  }, {
    key: "serializeSegmentationModelItem",
    value: function serializeSegmentationModelItem() {
      return function (object) {
        return {
          salesLift: object.salesLift,
          profitLift: object.profitLift,
          value: object.value
        };
      };
    }
  }]);

  return SegmentationModelConverterImpl;
}(SegmentationModelConverter_1.SegmentationModelConverter);

exports.SegmentationModelConverterImpl = SegmentationModelConverterImpl;